// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'shield-currency';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M9.344 12.938A2.156 2.156 0 1 0 11.5 10.78a2.156 2.156 0 1 1 2.156-2.156M11.5 5.031V6.47m0 8.624v1.437' />
    <path d='M21.563 8.984A12.862 12.862 0 0 1 11.5 21.563 12.862 12.862 0 0 1 1.437 8.983v-5.03a2.516 2.516 0 0 1 2.516-2.517h15.094a2.516 2.516 0 0 1 2.515 2.516Z' />
  </g>
);

export const viewBox = '-0.5 -0.5 24 24';
